var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMadeLocally(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "47px",
    viewBox: "0 0 52 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Made Locally") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Made-Locally"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.759675)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    stroke: "#979797",
    strokeWidth: 1.5,
    points: "0 17 24.9665582 0 50 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10",
    stroke: "#979797",
    strokeWidth: 1.5,
    points: "6 17 6 45 43 45 43 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-11",
    stroke: "#979797",
    strokeWidth: 1.5,
    points: "43 12 43 1 37 1 37 3.84330745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5420728,24 C23.8700018,28.0693105 23.8228645,31.2124244 24.400661,33.4293416 C24.9784574,35.6462588 25.8449038,37.1698116 27,38",
    id: "Path-12",
    stroke: "#979797",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6178319,33.5546934 C31.0398651,31.745977 32.4524537,29.2317002 31.8555979,26.0118628 C30.9603142,21.1821068 28.1511978,19.2364679 27,18.3978093 C26.2325348,17.8387036 25.2085488,17.0394338 23.9280421,16 C23.1751052,17.8714147 22.0188074,19.5987836 20.4591486,21.1821068 C18.1196606,23.5570914 16,25.7690975 16,27.9786905 C16,30.1882835 17.1375961,32.1874595 19.1421321,33.0780726 C20.4784895,33.6718147 21.9405048,33.8306883 23.5281781,33.5546934",
    id: "Path-13",
    stroke: "#979797",
    strokeWidth: 1.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadeLocally);
export default __webpack_public_path__ + "static/media/madeLocally.ad0e6be9bbcedd14a5898723316c0fc2.svg";
export { ForwardRef as ReactComponent };